<template>
  <div>
    <v-navigation-drawer app temporary v-model="drawer" color="red" dark>
      <!-- -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-img
              class="mb-1"
              src="../assets/canoninverted.svg"
              max-height="90"
              max-width="110"
              contain
            ></v-img>
          </v-list-item-title>
          <v-list-item-subtitle class="title font-weight-light">Cost Calculator</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav dark>
        <v-list-item
          v-for="(link, index) in links"
          :key="index"
          link
          :to="link.link"
          active-class="tile"
        >
          <v-list-item-icon>
            <v-icon>mdi-{{ link.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ link.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="red" dark elevate-on-scroll>
      <!-- -->

      <router-link to="/">
        <v-img
          class="mx-2"
          src="../assets/canoninverted.svg"
          max-height="60"
          max-width="100"
          contain
        ></v-img>
      </router-link>
      <v-toolbar-title class="font-weight-light pt-2 pl-1">Cost Calculator</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn v-for="link in links" text :key="link.name" :to="link.link" class="px-2">
          <v-icon class="px-1">mdi-{{link.icon}}</v-icon>
          <span>{{link.name}}</span>
        </v-btn>
        <!--         <v-btn text to="/papers" class="px-2">
          <v-icon class="px-1">mdi-note</v-icon>
          <span>Papers</span>
        </v-btn>
        <v-btn text to="/printer" class="px-2">
          <v-icon class="px-1">mdi-printer</v-icon>
          <span>Printer</span>
        </v-btn>

        <v-btn text to="/settings" class="px-2">
          <v-icon class="px-1">mdi-settings</v-icon>
          <span>Indstil.</span>
        </v-btn>-->
      </v-toolbar-items>

      <v-app-bar-nav-icon @click="drawer=!drawer" class="hidden-md-and-up"></v-app-bar-nav-icon>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  beforeCreate: function() {
    this.$store.dispatch('getSettings');
    this.$store.dispatch('getPapers');
  },
  data: () => ({
    //
    drawer: false,
    test: 'test',
    links: [
      { link: '/jobs', icon: 'newspaper-variant-multiple', name: 'Jobs' },
      { link: '/papers', icon: 'note', name: 'Papers' },
      { link: '/printer', icon: 'printer', name: 'Printer' },
      { link: '/settings', icon: 'settings', name: 'Settings' }
    ]
  })
};
</script>


<style scoped>
.tile:active {
  color: white;
  font-weight: bold;
}
.tile {
  color: white;
}
</style>
